import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../assets/lang/en";
import tr from "../assets/lang/tr";

const languageDetector = {
  type: "languageDetector",
  async: true,
  detect: (cb) => cb("tr"),
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "tr",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        ...en,
      },
      tr: {
        ...tr,
      },
    },
  });

export default i18n;
